/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {
	accountEmailChangeSceneActivated,
	accountEmailChangeSceneStateChanged,
	accountEmailChangeSceneStateRetrieved,
	ActionTypes
} from './actions';
import {getType} from 'typesafe-actions';
import {DisplayType} from './displayType';

export interface AccountEmailChangeState {
	displayType: DisplayType;
}

const initialState: AccountEmailChangeState = {
	displayType: DisplayType.DISPLAY_TYPE_NONE
};

const reducer = (state: AccountEmailChangeState = initialState, action: ActionTypes): AccountEmailChangeState => {
	switch (action.type) {
		case getType(accountEmailChangeSceneActivated):
			return initialState;
		case getType(accountEmailChangeSceneStateRetrieved):
		case getType(accountEmailChangeSceneStateChanged):
			switch (action.payload.state.status) {
				case 'INITIALIZING':
				case 'STOPPED_WITH_DENIED_EMAIL_OWNERSHIP':
				case 'STOPPED_WITH_TECHNICAL_FAILURE':
				case 'STOPPED_AT_CLIENTS_REQUEST':
				case 'STOPPED_WITH_VERIFICATION_TIMEOUT':
				case 'STOPPED_WITH_ACCOUNT_ACCESS_BLOCKED':
				case 'WAITING_TO_BE_VERIFIED':
					return {displayType: DisplayType.DISPLAY_TYPE_LOADING};
				case 'VERIFIED':
					return {displayType: DisplayType.DISPLAY_TYPE_VERIFIED};
				case 'OUTDATED':
					return {displayType: DisplayType.DISPLAY_TYPE_OUTDATED};
				default:
					return {displayType: DisplayType.DISPLAY_TYPE_NONE};
			}
		default:
			return state;
	}
};

export default reducer;
